import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { MAT_DIALOG_DATA, MatTableDataSource, MatDialogRef, MatDialog } from '@angular/material';
import { RegisterMarkComponent } from '../register-mark/register-mark.component';
import { StudentSessionsCheckoutService } from 'src/app/services/http/business/StudentSessionsCheckout/student-sessions-checkout.service';
import { DetailsMarkComponent } from '../details-mark/details-mark.component';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { ErrorsService } from 'src/app/services/common/errors.service';



@Component({
  selector: 'app-student-list',
  templateUrl: './student-list.component.html',
  styleUrls: ['./student-list.component.css']
})
export class StudentListComponent implements OnInit {
  form: FormGroup;
  sessionList: any;
  courseService: any;
  fullTime: any;
  filter: any;
  allSession = [];
  skip: number = 0;
  selectAll: boolean;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "attendance",
    "name",
    "nationalCode",
    "mobile",
    "mark",
    //"registrationStatus",
    //"finalPayment",
    "function"
  ];
  data: any;
  param: string[];
  errors: any[];
  errObject: any[];
  constructor(
    private fb: FormBuilder,
    private studentSessionsCheckoutService: StudentSessionsCheckoutService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<StudentListComponent>,
    @Inject(MAT_DIALOG_DATA) public dataParams: any
  ) { }

  ngOnInit() {
    this.createForm();
    this.refresh();
  }
  refresh() {
    this.studentSessionsCheckoutService.getStudentAttendance(this.dataParams).subscribe(res => {

      // console.log(this.data);
      //console.log(res);
      this.dataSource = res.xRegisterMain;
      this.data = res.xRegisterMain;
      this.data.forEach(item => {
        // element.Attendance.forEach((item: any) => {
        if (item.Attendance.AttendanceStatusId == 91) {
          item.Attendance["isSelectItem"] = true;
          item["isSelectItem"] = true;
          // this.check(item.AttendanceStatusId);
        } else if (item.Attendance.AttendanceStatusId == 92) {
          item.Attendance["isSelectItem"] = false;
          item["isSelectItem"] = false;
          // this.check(item.AttendanceStatusId);
        } else {
          item.Attendance["isSelectItem"] = null;
          item["isSelectItem"] = null;
        }
        this.allSession.push(item);
        //  });
      });
      if (this.allSession.length != 0) {
        this.selectAll = null;
      }

    }, () => { })
  }
  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [null, Validators.required],
      IsCheckout: [null, Validators.required],

    });
  }

  check(allSessionStatusId: number) {
    switch (allSessionStatusId) {
      case 91:
        return true;
      case 92:
        return false;
      default:
        return null;
    }
  }

  operationSelectAll(statusId: number, eventChecked: boolean) {

    console.log(this.fullTime);
    this.sessionList = [];

    this.data.forEach(item => {
      //  item.Attendance.forEach(element => {

      item.Attendance["isSelectItem"] = eventChecked;
      item["isSelectItem"] = eventChecked;
      this.sessionList.push({
        "RegisterId": item.Attendance.RegisterId,
        "CourseAllSessionId": item.Attendance.CourseAllSessionId,
        "AttendanceStatusId": statusId
      });
      this.check(statusId);
      // });
    });

    console.log(this.sessionList);
  }

  checkAllSessions() {

    if (this.selectAll)
      this.operationSelectAll(91, true);

    else
      this.operationSelectAll(92, false);

  }

  checkList(event, student) {

    if (this.selectAll != null) {
      this.selectAll = false;
    }

    if (this.sessionList == null) {
      this.sessionList = [];
    }

    if (this.sessionList.map(function (e) { return e.RegisterId; }).indexOf(student.RegisterId) < 0) {

      if (event.checked) {
        this.sessionList.push({
          "RegisterId": student.RegisterId,
          "CourseAllSessionId": student.CourseAllSessionId,
          "AttendanceStatusId": 91
        });
        student.isSelectItem = true;
      }
      else {
        this.sessionList.push({
          "RegisterId": student.RegisterId,
          "CourseAllSessionId": student.CourseAllSessionId,
          "AttendanceStatusId": 92
        });
        student.isSelectItem = false;
      }
    }
    else {
      if (event.checked) {
        this.sessionList[this.sessionList.map(function (e) { return e.RegisterId; })
          .indexOf(student.RegisterId)].AttendanceStatusId = 91, student.isSelectItem = true;
      }
      else {
        this.sessionList[this.sessionList.map(function (e) { return e.RegisterId; })
          .indexOf(student.RegisterId)].AttendanceStatusId = 92, student.isSelectItem = false;
      }
    }
  }
  //  student registration mark
  registerMark(item: any): void {

    let command: any = {

      CourseId: this.dataParams.CourseId,
      AllSessionId: this.dataParams.AllSessionId,
      RegistrationId: item.Id,
      StudentFullName: item.FullName,
      NationalCode: item.NationalCode,
      dataDefault: this.dataParams,
      Attendance: item.Attendance
    };
    this.dialog.open(RegisterMarkComponent, {
      data: command,
      disableClose: true,
      width: "850px",
    })
      .afterClosed()
      .subscribe(() => { });
  }
  //  student details Mark
  detailsMark(item: any): void {

    this.dialog.open(DetailsMarkComponent, {
      data: item,
      disableClose: true,
      width: "350px",
    })
      .afterClosed()
      .subscribe(() => { });
  }

  checkFullTime(time: Date, _index, room, session): any {
    var res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test) {
        test.RoomTimeList.forEach(element => {
          if (time >= element.TimeStart && time < element.TimeEnd) {
            this.skip = this.calcWidth(element.TimeStart, element.TimeEnd);
            res = true;
            session.teacher = element;
            return res;
          }
        });
      }
    }
    if (this.skip > 0) {
      this.skip = this.skip - 1;
    }

    return res;
  }


  submitSessions() {

    let attendanceStatus: any = [];

    this.sessionList.forEach(element => {
      attendanceStatus.push({
        "RegisterId": element.RegisterId,
        "CourseAllSessionId": element.CourseAllSessionId,
        "AttendanceStatusId": element.AttendanceStatusId
      });
    });

    this.studentSessionsCheckoutService.saveStudentAttendance(attendanceStatus).subscribe(() => {

      this.snackBar.OpenSnackBar(
        this.translate.get("success.attendance"),
        "ok",
        5000,
        SoundEnum.beep
      );
      this.refresh();
    },
      () => {

      });
  }

  calcWidth(timeStart, timeEnd) {
    var timeS = Number(timeStart.split(':')[0]) * 60 * 60 * 1000 + Number(timeStart.split(':')[1]) * 60 * 1000;
    var timeE = Number(timeEnd.split(':')[0]) * 60 * 60 * 1000 + Number(timeEnd.split(':')[1]) * 60 * 1000;
    return Math.ceil(((timeE - timeS) / (1000 * 60 * 15)));
  }

  setToFinal() {

    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.defineTheScores", {
        name: this.translate.get("label.defineTheScores")
      }),
      alert: this.translate.get("alert.defineTheScores", {
        name: this.translate.get("label.defineTheScores")
      }),
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "350px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {

          if (res) {
            let command = {
              CourseId: this.dataParams.CourseId,
              IsFinal: true
            };
            this.studentSessionsCheckoutService.setToFinal(command).subscribe(() => {

              this.snackBar.OpenSnackBar(
                this.translate.get("success.defineTheScoresRecording"),
                "ok",
                5000,
                SoundEnum.beep
              );

            }, (error) => {
              this.errObject = this.errorService.getError(error);
              this.param = this.errorService.objectError(this.errObject);
              this.errors = this.errorService.returnError(error);
              this.snackBar.OpenSnackBar(
                // this.translate.get("error.defineTheScoresRecording"),
                // this.translate.get("label.error"),
                this.translate.get(`serviceErrors.${this.errors[0]}`),
                "ok",
                7000,
                SoundEnum.beep
              );

            });
          }
        },
        error => {
          this.errorService.recordHasBennUsed(error);

        }
      );
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
